"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchedAircraft = exports.editAircraft = exports.createAircraft = exports.removePilotAircraft = exports.addPilotAircraft = exports.getPilotAircraft = void 0;
const request_1 = __importStar(require("./request"));
const handleError_1 = require("./handleError");
const getPilotAircraft = async () => {
    try {
        const response = await (0, request_1.default)(request_1.GET, `pilot/me/aircraft`);
        const aircraft = await response.data;
        return aircraft;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getPilotAircraft = getPilotAircraft;
const addPilotAircraft = async (id) => {
    try {
        return await (0, request_1.default)(request_1.POST, `pilot/me/aircraft/${id}`);
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.addPilotAircraft = addPilotAircraft;
const removePilotAircraft = async (id) => {
    try {
        const { data } = await (0, request_1.default)(request_1.DELETE, `pilot/me/aircraft/${id}`);
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.removePilotAircraft = removePilotAircraft;
const createAircraft = async (payload) => {
    try {
        const { data } = await (0, request_1.default)(request_1.POST, 'aircraft/', payload);
        return data.id;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.createAircraft = createAircraft;
const editAircraft = async (id, payload) => {
    try {
        const { data } = await (0, request_1.default)(request_1.PUT, `aircraft/${id}`, payload);
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.editAircraft = editAircraft;
const getSearchedAircraft = async (query) => {
    try {
        const response = await (0, request_1.default)(request_1.GET, `aircraft/?query=${query}`);
        const aircraft = await response.data;
        return aircraft;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getSearchedAircraft = getSearchedAircraft;
